<template>
  <v-row class="flex-column mt-6 pr-8">
    <router-view :key="$route.fullPath" />
    <v-col v-if="$route.name === 'BusinessFunction'">
      <v-row no-gutters>
        <v-col md="2"
          ><h2 class="title-1 ml-5 primary-text">Business Function</h2>
        </v-col>
        <v-col class="text-right">
          <v-btn icon class="mr-1" @click="resetAll">
            <v-icon>restart_alt</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            class="custom-search"
            label="Search"
            solo
            append-icon="search"
            hide-details
            single-line
            @keyup="getBusinessList(), pageReset()"
          />
          <v-btn
            class="primary_btn small"
            depressed
            @click="$router.push({ name: 'addBusinessFunction' })"
          >
            Add Business Function
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="$route.name === 'BusinessFunction'" class="custom-panel">
      <v-data-table
        id="businessFunction"
        :options.sync="options"
        :server-items-length="vsmList.total"
        :sort-desc.sync="sortDesc"
        :headers="headers"
        hide-default-footer
        :header-props="{ sortIcon: 'arrow_upward' }"
        :items="vsmList.data"
        :loading="loading"
        class="elevation-1"
        @update:sort-desc="getBusinessList"
      >
        <template v-slot:item.domainName="{ item }">
          <b>
            {{ item.domainName }}
          </b>
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row>
            <v-col cols="2">
              <v-btn icon>
                <v-icon
                  @click="
                    $router.push(
                      `/businessfunction/view-businessFunction/${item.vsmId}`,
                    )
                  "
                  >visibility</v-icon
                >
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn icon>
                <v-icon
                  @click="
                    $router.push(
                      `/businessfunction/edit-businessFunction/${item.vsmId}`,
                    )
                  "
                  >edit</v-icon
                >
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <div class="primary-icon">
        <license-pagination
          :total="vsmList.total"
          :value="page"
          @input="pageEmit"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import licensePagination from '@/components/LicensePagination/licensePagination.vue';
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '@/store/actions.constants';
// import { storeActions } from '@/store/actions.constants';
export default {
  components: { licensePagination },
  data: () => ({
    headers: [
      {
        text: 'Business Type',
        align: 'start',
        value: 'domainName',
      },
      { text: 'Value Stream', value: 'name' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    search: '',
    loading: false,
    page: 1,
    itemsPerPage: 10,
    sortDesc: [],
    options: {},
  }),
  computed: {
    ...mapGetters({
      vsmList: 'businessFunction/getVsm',
    }),
  },
  async mounted() {
    if (this.options.page !== undefined) await this.getBusinessList();
  },
  methods: {
    ...mapActions({
      getVsmList: 'businessFunction/getVsmList',
    }),
    pageReset() {
      if (this.search) {
        this.page = 1;
      }
    },
    pageEmit(data) {
      if (data > 0) this.page = data;
      this.getBusinessList();
    },
    resetAll() {
      this.search = '';
      this.page = 1;
      this.sortDesc = [];
      this.options.sortBy.length = 0;
      this.getBusinessList();
    },
    getBusinessList() {
      this.loading = true;
      const { sortBy } = this.options;
      this.getVsmList({
        page: this.page,
        limit: 10,
        search: this.search || '',
        sort: sortBy[0],
        desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
